/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Enum representation of a platform user role. Should be used on the Core layer instead of strings. Maps string values from Entra ID into a value from a limited set of values (this enum). This allows for easier handling of user roles and provides a clear and consistent way to represent user roles throughout the application.
 */
export const UserAuthRole = {
    User: 1,
    Member: 2,
    Admin: 3,
    SuperAdmin: 4
} as const;
export type UserAuthRole = typeof UserAuthRole[keyof typeof UserAuthRole];

